import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "@/i18n";

export default function Faq() {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-t border-line py-24 lg:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="font-mono flex items-center gap-3 text-[11px] font-bold tracking-[0.25em] text-obsidian/60">
              <span className="h-2 w-2 rotate-45 bg-brand" />
              {t.faq.eyebrow}
            </p>
            <h2 className="font-display font-expanded mt-5 text-3xl font-black uppercase tracking-tight text-obsidian sm:text-4xl lg:text-5xl">
              {t.faq.title}
            </h2>
          </Reveal>

          <div className="lg:col-span-8">
            {t.faq.items.map((item, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div data-testid={`faq-item-${i + 1}`} className="border-b border-line first:border-t">
                  <button
                    data-testid={`faq-toggle-${i + 1}`}
                    onClick={() => setOpen(open === i ? -1 : i)}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-display text-lg font-extrabold tracking-tight text-obsidian sm:text-xl">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                        open === i ? "rotate-45 border-brand bg-brand text-obsidian" : "border-obsidian/20 text-obsidian"
                      }`}
                    >
                      <Plus className="h-4 w-4" />
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open === i && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        className="overflow-hidden"
                      >
                        <p className="max-w-3xl pb-7 text-sm leading-relaxed text-obsidian/65 sm:text-base">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
